import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  vmsTreeLayout(id, idType, hypervisorType) {
    return axios.get(`${baseUrl}/virtual/virtualmap/get-virtual-map-data.do`, {
      params: {
        id,
        idType,
        hypervisorType,
      },
    });
  },
  /**
   * 가상화 타임라인 데이터 조회
   * @author kimjy
   * @param  {Object} params objId, objtypeId, timelineTypes
   */
  getVirtualTimelineData(params) {
    return axios.post(`${baseUrl}/virtual/virtualmap/get-virtual-timeline-data.do`, params);
  },
  /**
   * 가상화 장비들의 이벤트 발생건수, 장비 갯수 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getVirtualMapObjEventInfo(params) {
    return axios.post(`${baseUrl}/virtual/virtualmap/get-virtual-map-obj-event-info.do`, params);
  },
  /**
   * 가상화맵 > 장비 이벤트 조회
   * @author Song
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getEventStatusListForVirtualMap(params) {
    return axios.get(`${baseUrl}/virtual/virtualmap/get-event-status-list-for-virtual-map.do?objId=${params.objId}`);
  },
  /**
   * 가상화맵 > 장비 성능정보 조회
   * @author Song
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getOrderNRscRslt(params) {
    return axios.post(`${baseUrl}/virtual/virtualmap/get-ordern-rslt-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/virtual/performance/virtualmap.js